export default "__VITE_ASSET__tVZj68Ew__"